import { InboxOutlined } from '@ant-design/icons';
import { Button, Form, Upload } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../utils';
import { Smat } from '../../models';

export function SmatFileUploadPage(props: { smat?: Smat; onComplete: () => void }) {
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<any[]>();

  const { Dragger } = Upload;

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    setUploadedFiles(e.fileList.map((f: any) => f.originFileObj));
    return e && e.fileList;
  };

  const dummyUploadRequest = ({ onSuccess }: any) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const onFinish = () => {
    setLoading(true);

    var formData = new FormData();

    if (uploadedFiles?.length) {
      for (let i = 0; i < uploadedFiles?.length; i++) {
        formData.append(`files[${i}]`, uploadedFiles[i]);
      }
    }

    apiClient
      .post(`smats/${props.smat?.id}/documents`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        props.onComplete();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form name="basic" onFinish={onFinish}>
      <Form.Item
        name="dragger"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        noStyle
        rules={[{ required: true, message: 'Zorunlu alan' }]}
      >
        <Dragger name="files" multiple={true} customRequest={dummyUploadRequest}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Bir dosya sürükleyin veya tıklayın</p>
        </Dragger>
      </Form.Item>
      <Form.Item style={{ marginTop: '2rem', textAlign: 'center' }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Ekle
        </Button>
      </Form.Item>
    </Form>
  );
}
